"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designSystem = require("@slyk/design-system");

var _media = require("react-components/media");

var _styles = require("./styles");

var _styles2 = require("react-components/styles");

var _breakpoint = require("@slyk/breakpoint");

var _react = _interopRequireWildcard(require("react"));

var _qs = _interopRequireDefault(require("qs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var googleIcon16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><path fill=\"currentColor\" d=\"M15 8.66c0-.475-.04-.954-.123-1.422H8.14v2.696h3.857a3.237 3.237 0 01-1.427 2.127v1.749h2.301C14.223 12.59 15 10.79 15 8.66z\"/><path fill=\"currentColor\" d=\"M8.14 15.5c1.926 0 3.55-.62 4.734-1.69l-2.302-1.748c-.64.427-1.466.668-2.43.668-1.863 0-3.442-1.232-4.01-2.888H1.759v1.803C2.97 14.009 5.44 15.5 8.14 15.5z\"/><path fill=\"currentColor\" d=\"M4.13 9.84c-.3-.869-.3-1.81 0-2.68V5.357H1.758a6.882 6.882 0 000 6.287L4.13 9.84z\"/><path fill=\"currentColor\" d=\"M8.14 4.27a3.924 3.924 0 012.74 1.05l2.038-1.998A6.941 6.941 0 008.14 1.5c-2.7 0-5.17 1.492-6.382 3.859L4.13 7.162c.564-1.66 2.147-2.891 4.01-2.891z\"/></svg>";
var googleIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M22.5 12.741c0-.714-.059-1.431-.185-2.134H12.211v4.044h5.786a4.856 4.856 0 01-2.141 3.19v2.624h3.452c2.027-1.829 3.192-4.53 3.192-7.724z\"/><path fill=\"currentColor\" d=\"M12.21 23c2.889 0 5.325-.93 7.1-2.535l-3.45-2.625c-.96.64-2.2 1.003-3.645 1.003-2.795 0-5.165-1.848-6.015-4.332H2.637v2.704C4.455 20.762 8.159 23 12.21 23z\"/><path fill=\"currentColor\" d=\"M6.196 14.512a6.171 6.171 0 010-4.02V7.787H2.638a10.323 10.323 0 000 9.43l3.558-2.705z\"/><path fill=\"currentColor\" d=\"M12.21 6.156a5.887 5.887 0 014.11 1.574l3.058-2.998a10.412 10.412 0 00-7.168-2.731C8.16 2 4.455 4.238 2.637 7.788l3.558 2.704c.846-2.488 3.22-4.336 6.015-4.336z\"/></svg>";

/**
 * Google authentication url.
 */
var googleAuthenticationUrl = "https://accounts.google.com/o/oauth2/v2/auth";
/**
 * `Props` type.
 */

/**
 * `GoogleSocialButton` styled component.
 */
var GoogleSocialButton = (0, _styledComponents["default"])(_designSystem.Button).withConfig({
  displayName: "google-button__GoogleSocialButton",
  componentId: "sc-yt5i5e-0"
})(["margin-bottom:", ";transition-property:background-color,color,opacity;&,&:focus,&:hover{background-color:", ";color:", ";}&:disabled{opacity:0.5;}"], (0, _styles2.units)(1), (0, _styles2.color)('google'), (0, _styles2.color)('white'));
/**
 * `GoogleButton` component.
 */

function GoogleButton(props) {
  var children = props.children,
      credentials = props.credentials,
      disabled = props.disabled,
      responsive = props.responsive;
  var isDesktop = (0, _breakpoint.useBreakpoint)('ms', 'min');
  var isResponsive = !!responsive;
  var iconButton = isDesktop ? googleIcon24 : googleIcon16;
  var iconSize = isDesktop ? (0, _styles2.units)(3) : (0, _styles2.units)(2);
  var googleUrl = (0, _react.useMemo)(function () {
    var _credentials$state;

    var params = {
      client_id: credentials.clientId,
      nonce: credentials.clientId,
      redirect_uri: credentials.redirectUrl,
      response_type: 'id_token token',
      scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
      state: _qs["default"].stringify(_objectSpread({
        identityProvider: 'google',
        scope: 'authentication',
        slug: credentials.slug,
        type: credentials.type
      }, (_credentials$state = credentials.state) !== null && _credentials$state !== void 0 ? _credentials$state : {}))
    };
    var url = new URL(googleAuthenticationUrl);
    url.search = _qs["default"].stringify(params);
    return url.href;
  }, [credentials]);
  return /*#__PURE__*/_react["default"].createElement(GoogleSocialButton, {
    disabled: disabled,
    fullWidth: true,
    href: googleUrl,
    responsive: responsive,
    size: 'large'
  }, /*#__PURE__*/_react["default"].createElement(_styles.SocialButtonContent, null, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: (0, _styles2.color)('white'),
    icon: isResponsive ? iconButton : googleIcon24,
    size: isResponsive ? iconSize : (0, _styles2.units)(3)
  }), children));
}
/**
 * Export `GoogleButton` component.
 */


var _default = GoogleButton;
exports["default"] = _default;